import { PropsWithChildren } from "react";

type Props = PropsWithChildren;

export const EntriesList: React.FC<Props> = ({ children }) => {
  return <div css={{ display: "flex", flexDirection: "column", gap: "1rem", width: "100%" }}>{children}</div>;
};
